import BigNumber from 'bignumber.js';
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { action, computed, observable, toJS } from 'mobx';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BasesController } from '../bases';

@BindAll()
export class RapidQuotationProductController<
  T = any,
> extends BasesController<T> {
  constructor() {
    super();
    this.reset({
      dataKey: 'productId',
      infinite: true,
      pagination: EnumAPI.rapidQuotation_productList,
      details: EnumAPI.product_detail,
      paginationParams: {
        currentKey: 'pageNo',
        pageSizeKey: 'pageSize',
        response: {
          dataSource: 'productList',
          total: 'total',
          valueGetter: this.valueGetter,
        },
      },
    });
  }
  /**
   * 查询商品
   * @param body
   * @returns
   */
  async onProductSearch(body) {
    const response: any = await AjaxBasics.request({
      ...EnumAPI.rapidQuotation_productList,
      body,
    });
    const product = lodash.find(response.productList, (item) => {
      return item.productId == body.productId;
    });
    return product;
  }
  // 清空已存储的商品列表
  @action
  onClear() {
    this.productList = [];
    this.distributorOptions = { value: [] };
  }

  /**
   * 新增智能报价时的产品列表
   */
  @observable productList = [];

  @action
  addProductToList(product) {
    this.productList.push(product);
  }

  @action
  updatingProduct(productId, values) {
    const index = this.convertProductToIndex(productId);
    const productList = toJS(this.productList);
    return this.productList.splice(index, 1, {
      ...productList[index],
      ...values,
    });
  }
  convertProductToIndex(productId) {
    const index = toJS(this.productList).findIndex((item) => {
      return item.productId == productId;
    });
    return index;
  }

  @action
  getCurrentPrice(productId) {
    return lodash.get(this.productList, `[${productId}].price`);
  }

  @action
  removeProductFromList(productId) {
    const index = this.convertProductToIndex(productId);
    this.productList.splice(index, 1);
  }

  /**
   * 保存服务商列表
   */
  @observable distributorOptions = {
    value: [],
  };
  @action
  updatingDistributorOptions(distributorOptions) {
    lodash.set(this.distributorOptions, 'value', distributorOptions);
  }

  /**
   * 获取服务商列表信息
   * @param res
   * @returns
   */
  async getProductPrice(body) {
    return await AjaxBasics.request({
      ...EnumAPI.rapidQuotation_productPrice,
      body,
    });
  }

  /**
   * 获取某款商品的阶梯价格
   * @param res
   * @returns
   */
  async getDistributor() {
    return await AjaxBasics.request(EnumAPI.rapidQuotation_getDistributor);
  }
  /**
   * 计算所选产品总金额
   * @param res
   * @returns
   */
  @computed
  get totalAmount() {
    let amount = new BigNumber(0);
    lodash.each(this.productList, (item) => {
      const price = new BigNumber(item.tieredPrice);
      const number = new BigNumber(item.number);
      amount = amount.plus(price.times(number));
    });
    return amount.toFixed(2);
  }

  // 调用计算产品价格接口时的loading状态
  @observable getCalcPriceLoading = false;
  @action
  setCalcPriceLoading(loading) {
    this.getCalcPriceLoading = loading;
  }
  @observable getCalcPriceBtnDisabled = false;
  @action
  setCalcPriceBtnDisabled(disabled) {
    this.getCalcPriceBtnDisabled = disabled;
  }

  valueGetter(res) {
    const dataSource = lodash.map(lodash.get(res, 'productList'), (item) => {
      return lodash.merge(item, {
        number: 1,
      });
    });
    return {
      dataSource,
    };
  }

  /**
   * 智能报价单提交
   * @param res
   * @returns
   */
  async rapidQuotation_submit(body) {
    return await AjaxBasics.request({
      ...EnumAPI.rapidQuotation_submit,
      body,
    });
  }
}
